import { render, staticRenderFns } from "./AddEditPosition.vue?vue&type=template&id=d20ca3e8"
import script from "./AddEditPosition.vue?vue&type=script&lang=js"
export * from "./AddEditPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports